/* ═══════════════════════════════════════════════════════════
   BOOK TAXONOMY — shared between reader preferences & book tagging
   Every item uses three-way toggle:
     Preferences: unset / want / avoid
     Tags:        unset / present / absent
═══════════════════════════════════════════════════════════ */

export const BOOK_TAXONOMY = [
  { key: 'steamLevel', title: 'Steam Level', groups: [
    { label: 'Level', items: ['Glimpses and kisses', 'Behind closed doors', 'Open door', 'Explicit open door', 'Explicit and plentiful'] },
  ]},
  { key: 'genres', title: 'Genre', groups: [
    { label: 'Fantasy', items: ['High fantasy', 'Urban fantasy', 'Steampunk'] },
    { label: 'Paranormal', items: ['Magic', 'Time travel', 'Angels', 'Demons', 'Fae', 'Monsters', 'Orcs', 'Shapeshifters (werewolves)', 'Dragon shifter', 'Bear shifter', 'Vampires', 'Witches'] },
    { label: 'Other', items: ['Science fiction / aliens', 'Dark romance', 'Young adult', 'New adult', 'Mystery', 'Suspense', 'Dystopian', 'Omegaverse', 'Funny', 'Angst', 'Horror'] },
  ]},
  { key: 'relationship', title: 'Relationship', groups: [
    { label: 'Type', items: ['M-F romance', 'Gay romance', 'Lesbian romance', 'Non-binary romance', 'Queer romance / queer awakening'] },
  ]},
  { key: 'tropes', title: 'Tropes', groups: [
    { label: 'Opposites attract', items: ['Age gap', 'Boss & employee', 'Class difference', 'Grumpy & sunshine', 'Height difference', 'Multicultural', 'Arranged marriage', 'Caretaking', 'Enemies to lovers', 'Fake relationship', 'Fated mates'] },
    { label: 'Forbidden love', items: ["Best friend's parent", "Parent's best friend", 'Step siblings'] },
    { label: 'Other tropes', items: ['Forced proximity', 'Friends to lovers', 'Friends with benefits', 'Good grovel', 'Hurt/comfort', 'Insta-love', 'Marriage of convenience', 'Love triangle', 'Cheating', 'Pregnancy', 'Second chances', 'Secret child', 'Secret relationship', "Sibling's best friend", 'Slow burn'] },
  ]},
  { key: 'kinks', title: 'Kinks and Play', groups: [
    { label: 'Dynamic', items: ['Fem-dom', 'Masc-dom', 'Role switching'] },
    { label: 'BDSM', items: ['Bondage', 'Spanking', 'Breeding', 'Consensual non-consent', 'Daddy kink'] },
    { label: 'Other', items: ['Menage', 'Reverse harem', 'Poly (MMF, MFM, MFF, MMM+)'] },
  ]},
  { key: 'storyElements', title: 'Story Elements', groups: [
    { label: 'Plot', items: ['Betrayal', 'Found family', 'Political/court intrigue', 'Mafia', 'Military', 'Neurodivergent MC', 'Survival', 'Vengeance', 'War', 'Cliffhanger', 'Disability & scars', 'Christmas'] },
  ]},
  { key: 'contentWarnings', title: 'Content Warnings', groups: [
    { label: 'Warnings', items: ['No HEA', 'Abuse between MCs', 'Third party abuse', 'Past abuse', 'Animal death', 'Dubious consent', 'Graphic violence', 'Mental illness / mental trauma', 'Self harm', 'Suicide/ideation', 'Torture of MCs'] },
  ]},
  { key: 'heroine', title: 'Heroine', groups: [
    { label: 'Personality', items: ['Cheerful', 'Competent', 'Grumpy/ice queen', 'Independent', 'Sassy', 'Shy', 'Sweet/gentle', 'Take-charge'] },
    { label: 'Circumstances', items: ['Dangerous', 'Gifted/super-heroine', 'Non-human', 'Poor', 'Rich', 'Tortured', 'Virgin'] },
    { label: 'Occupation', items: ['Aristo/royal', 'Bodyguard/protector', 'Criminal', 'Sleuth', 'Warrior', 'Working class'] },
    { label: 'Age', items: ['Early 20s', 'Late 20s', 'In her 30s', 'In her 40s/50s', '100+ years old'] },
  ]},
  { key: 'hero', title: 'Hero', groups: [
    { label: 'Personality', items: ['Alpha male', 'Bad boy', 'Cruel/bully', 'Grumpy/cold', 'Himbo', 'Nerdy', 'Possessive', 'Shy', 'Sunny/happy', 'Sweet/gentle'] },
    { label: 'Circumstances', items: ['Immortal', 'Non-human', 'Rich', 'Tortured', 'Virgin'] },
    { label: 'Occupation', items: ['Royal', 'Bodyguard/protector', 'CEO/tycoon', 'Fighter', 'Men in uniform', 'Pirate', 'Viking', 'Highlander', 'Warlord/commander', 'Working class'] },
    { label: 'Age', items: ['Early 20s', 'Late 20s', 'In his 30s', 'In his 40s/50s', '100+ years old'] },
  ]},
  { key: 'location', title: 'Location', groups: [
    { label: 'Setting', items: ['High school', 'College', 'Workplace/office', 'Small town', 'Western'] },
    { label: 'Geography', items: ['British Isles', 'Scandinavia', 'USA', 'Europe', 'Asia', 'Fantasy world'] },
  ]},
  { key: 'timePeriod', title: 'Time Period', groups: [
    { label: 'Era', items: ['Ancient times', 'Medieval', 'Tudor & Stuart', 'Georgian', 'Regency', 'Victorian', 'Western Frontier', 'American Civil War', '20th century', 'Contemporary', 'Futuristic / fantasy world'] },
  ]},
  { key: 'storyStructure', title: 'Story Structure', groups: [
    { label: 'Structure', items: ['Standalone', 'First in series', 'Series'] },
  ]},
  { key: 'pov', title: 'Point of View', groups: [
    { label: 'POV', items: ['Male POV', 'Dual POV', 'First person', 'Third person'] },
  ]},
  { key: 'length', title: 'Length', groups: [
    { label: 'Length', items: ['Novella (1-149 pages)', 'Short (150-249)', 'Medium (250-399)', 'Long (400-599)', 'Epic (600+)'] },
  ]},
];

// Three-way toggle: cycles unset → value1 → value2 → unset
export function cycleTagToggle(current) {
  if (!current) return 'present';
  if (current === 'present') return 'absent';
  return null;
}

export function cyclePrefToggle(current) {
  if (!current) return 'want';
  if (current === 'want') return 'avoid';
  return null;
}

/**
 * Resolve tags for a book from admin overrides + reader submissions.
 * Admin value always wins. Otherwise majority vote (min 3 submissions).
 * Returns { sectionKey: { itemName: { value, source, count } } }
 */
export function resolveBookTags(adminTags, submissions) {
  const resolved = {};
  const allSections = BOOK_TAXONOMY;

  for (const section of allSections) {
    resolved[section.key] = {};
    for (const group of section.groups) {
      for (const item of group.items) {
        // Check admin override first
        const adminVal = adminTags?.[section.key]?.[item];
        if (adminVal) {
          resolved[section.key][item] = { value: adminVal, source: 'admin', count: null };
          continue;
        }

        // Count reader submissions for this item
        const votes = { present: 0, absent: 0 };
        for (const sub of submissions) {
          const val = sub?.[section.key]?.[item];
          if (val === 'present') votes.present++;
          if (val === 'absent') votes.absent++;
        }

        const totalVotes = votes.present + votes.absent;
        if (totalVotes === 0) continue;

        const majority = votes.present >= votes.absent ? 'present' : 'absent';
        const majorityCount = Math.max(votes.present, votes.absent);

        if (majorityCount >= 3) {
          resolved[section.key][item] = { value: majority, source: 'community', count: majorityCount };
        } else {
          resolved[section.key][item] = { value: majority, source: 'unverified', count: totalVotes };
        }
      }
    }
  }
  return resolved;
}
